import { useLocalSearchParams } from 'expo-router';
import React from 'react';

import HouseholdScreen from '@/components/HouseholdScreen';

export default function CanvassHouseholdScreen() {
  const params = useLocalSearchParams();
  const addressId = params['addressId'] as string;
  const engagementId = params['engagementId'] as string;
  const battlePlanId = params['battlePlanId'] as string;

  return (
    <HouseholdScreen
      addressId={addressId}
      engagementId={engagementId}
      battlePlanId={battlePlanId}
      wakeLockId="canvassing-household"
      isPhoneEngagement={false}
    />
  );
}